import { useState } from "react";
import axios from "axios";

const useAxios = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const request = async ({ url, method = "get", body = null }) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios[method](url, body);
      setData(response.data);
      return response.data; // Devuelve los datos para poder encadenar promesas
    } catch (err) {
      setError(err);
      throw err.response.data; // Lanza el error para poder capturarlo en el componente
    } finally {
      setLoading(false);
    }
  };

  return { request, data, loading, error };
};

export default useAxios;
